define('view/controller/booking/provider/ProviderStepView',['require','lib/view/CompositeView','view/controller/booking/provider/ProviderItemView','view/controller/booking/provider/ProviderEmptyView'],function (require) {

	var CompositeView = require('lib/view/CompositeView');
	var ProviderItemView = require('view/controller/booking/provider/ProviderItemView');
	var ProviderEmptyView = require('view/controller/booking/provider/ProviderEmptyView');

	/**
	 * Provider composite view (providers container)
	 * 
	 * @class ProviderStepView
	 */
	return CompositeView.extend({
	
	    template: '#provider_step',
	    childView: ProviderItemView,
	    childViewContainer: '#sb_provider_step_container',
        
        emptyView: ProviderEmptyView,

		initialize: function () {
			this.filterModel = this.getOption('filterModel');

			this.listenTo(this.filterModel, 'change:query', this.render);
		},

		filter: function (child, index, collection) {
			var query = (this.filterModel && this.filterModel.get('query')) || '';
			if (!query) {
				return true;
			}

			var name = child.get('name') || '';
			var description = child.get('description') || '';
			
			return name.toLowerCase().indexOf(query.toLowerCase()) !== -1
				|| description.toLowerCase().indexOf(query.toLowerCase()) !== -1;
		},

        isEmpty: function (collection) {
            return collection._once_synced ? collection.isEmpty() : false;
        },

		emptyViewOptions: function () {
			return {
				'query': this.filterModel ? this.filterModel.get('query') : ''
			};
		},
        
		modelEvents: {
	    	'sync': 'renderView'
		},

		_pageId: 'booking_provider',

        renderView: function () {
	    	if (!this.isDestroyed) {
	    		this.render();
			}
		},

		serializeData: function () {
	    	return _.extend(CompositeView.prototype.serializeData.apply(this), {
	    		'error': this.model ? this.model.get('error') : null
			});
		}
	    
	});
	
});
